var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"anchorLinkContent",staticClass:"anchor-link-content"},[(_vm.headings.length)?_c('ul',_vm._l((_vm.headings),function(item){return _c('anchor-link-item-component',{key:item.id,attrs:{"anchor-link":item}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }